import React, { Component } from "react";

import {
  Wrapper,
  Card,
  ContentfulRichText,
  Title
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";
import Feature from "./Feature";

class BottomSection extends Component {
  renderButton(onboarding_landing_page) {
    if (
      this.props.plan_module_info.canceled != 1 &&
      this.props.plan_module_info.paused != 1 &&
      this.props.card_info.bad_card != 1 &&
      (this.props.plan_module_info.team_has_module == false ||
        this.props.plan_module_info.tier < this.props.require_tier) &&
      (this.props.plan_module_info.approved_to_charge == 1 ||
        this.props.plan_module_info.selected_plan == false ||
        this.props.plan_module_info.is_trial_over == false ||
        this.props.plan_module_info.is_trial_over == null) &&
      this.props.platform !== "ios"
    ) {
      return (
        <PillButton
          primary={true}
          style={{ marginLeft: 0 }}
          onPress={() => {
            this.props.setPricingPage({
              title: "Purchase Engine",
              engine_slug: this.props.slug,
              tier: this.props.require_tier ? this.props.require_tier : 1,
              frequency: "annually"
            });
            this.props.togglePricingPage(true);
          }}
        >
          {onboarding_landing_page.bottomPrimaryButtonText}
        </PillButton>
      );
    }
  }

  render() {
    const { onboarding_landing_page } = this.props;
    if (onboarding_landing_page && onboarding_landing_page.bottomTitle) {
      return (
        <Wrapper>
          <Wrapper
            style={{
              flexDirection: this.props.isMobile ? "column" : "row",
              alignItems: "center",
              justifyContent: "space-between",
              paddingTop: 0,
              padding: 25
            }}
          >
            {onboarding_landing_page.bottomFeatures &&
              onboarding_landing_page.bottomFeatures.map((feature, i) => {
                return (
                  <Feature
                    key={i}
                    feature={feature.fields}
                    isMobile={this.props.isMobile}
                  />
                );
              })}
          </Wrapper>
          <Wrapper style={{ padding: 25 }}>
            <Title style={{ marginBottom: 10 }}>
              {onboarding_landing_page.bottomTitle}
            </Title>
            <ContentfulRichText
              richText={onboarding_landing_page.bottomDescription}
            />

            {this.renderButton(onboarding_landing_page)}
          </Wrapper>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}
export default BottomSection;
